import { Injectable, Optional } from '@angular/core';
import { SeConstraintMatchingResult, SeEntityMatchingResult, SeConstraintItemMatchingResult } from '../view-models/view-model.constraint';
import { IConstraint } from '../models/model.constraint';
import { SeConstraintConfiguratorService } from '../se-constraint-configurator.service/se-constraint-configurator.service';
import { SeConstraintCheckerService } from '../se-constraint-checker.service/se-constraint-checker.service';
import { MatchingResult } from '../models/abstractions';
import { DataBinding, Logger } from '@se/se.ui.html5';
import { isBoolean } from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class SeConstraintValidatorService {

    constructor(
        private configService: SeConstraintConfiguratorService,
        private checkerService: SeConstraintCheckerService,
        @Optional() private logger: Logger
    ) { }

    public validate(): boolean {
        //valida tutti i constraint di tipo "validation"

        let listOfValidations = this.configService.validationConstraints;

        let res: boolean = true;
        for (let validation of listOfValidations)
            res = this.validateConstraint(validation) && res;

        return res;
    }

    public validateConstraint(constraint: IConstraint): MatchingResult {

        let res: SeConstraintMatchingResult = this.checkerService.checkConstraint(constraint)[0]; //per le validazioni il constraint non è mai multiplo

        let entityResult: SeEntityMatchingResult;
        for (entityResult of res.partialResults) {

            //Se sto cercando di validare un'entità che non esiste
            //allora non posso impostare in errore l'entità
            if (!entityResult.checkedEntity) {
                this.logger && this.logger.error(`Trying to validate an entity which does not exist. constraint id: ${constraint.id}, matchingResult: ${res.matchingResult}`);
                continue;
            }

            //se il metodo setPropertyErrorStatus non è implementato,
            //allora non posso impostare in errore l'entità
            if (!entityResult.checkedEntity.setPropertyErrorStatus) {
                this.logger && this.logger.error(`Trying to validate an entity without a setPropertyErrorStatus implementation. constraint id: ${constraint.id}, matchingResult: ${res.matchingResult}`);
                continue;
            }

            let itemResult: SeConstraintItemMatchingResult;
            let parameterIndex = 0;
            for (itemResult of entityResult.constraintItemResults) {

                let propName = new DataBinding(itemResult.constraintItem.propertyId).propertyName;

                //di default niente è in errore (condition fallita = successo della validazione).
                //Solo in caso di fallimento, poi mi segno le proprietà che sono in errore.
                let isMatching: boolean = true;

                if (res.matchingResult === false) {
                    isMatching = this.isValidItemResult(itemResult, constraint.formula, parameterIndex);
                }

                entityResult.checkedEntity.setPropertyErrorStatus(propName, 'seConstraint', isMatching);
                parameterIndex++;
            }
        }

        return res.matchingResult;
    }

    /**
     * Ritorna un booleano che indica se il risultato del matching del constraint item passato in input è valido o no.
     * Nelle validazioni tutti i constraint item devono essere regole che tornano un valore boolano.
     * Quindi, se il matching result non è un booleano,  il risultato non è valido.
     * In caso contrario, esso è valido a meno che nella formula non sia stato messo in NOT.
     * La validazione sui singoli item è da fare quando è necessario sapere
     * se mettere quel particolare dato in errore o meno, ovvero quando l'intera regola fallisce.
     */
    private isValidItemResult(itemResult: SeConstraintItemMatchingResult, constraintFormula: string, parameterIndex: number): boolean {

        if (isBoolean(itemResult.matchingResult))
            return this.isValidParameter(constraintFormula, itemResult.matchingResult, parameterIndex);

        return false;
    }

    private isValidParameter(formula: string, isMatching: boolean, parameterIndex: number) : boolean {
        if ((parameterIndex < 0) || !formula || (formula == ""))
            return isMatching;

        //cerco ad esempio NOT(C_1). I \s nella formula regex indicano gli spazi.
        let matchIndex = formula.search(`NOT\\s*\\(\\s*C_${parameterIndex}\\s*\\)`);

        if (matchIndex >= 0)
            return !isMatching

        return isMatching;
    }
}
